import React from "react";
import backgnd from "../../assets/images/About us.png";
import { Link } from "react-router-dom";

const WeareHere = ({ pagename }) => {
  return (
    <div style={{ position: "relative", overflow: "hidden" }}>
      {/* Background image */}
      <img
        src={backgnd}
        alt="Background"
        style={{
          width: "100%",
          height: "clamp(380px, 55vw, 650px)",
          objectFit: "cover",
          objectPosition: "center",
          display: "block",
        }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.6) 100%)",
        }}
      />

      {/* Content */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "2rem 1.5rem",
        }}
      >
        {/* Eyebrow rule */}
        <div
          className="d-flex align-items-center gap-3 mb-4"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <span
            style={{
              height: 1,
              width: 36,
              background: "rgba(255,255,255,0.45)",
              display: "block",
            }}
          />
          <span
            style={{
              fontSize: "0.68rem",
              fontWeight: 700,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.7)",
            }}
          >
            Athees Info Solutions
          </span>
          <span
            style={{
              height: 1,
              width: 36,
              background: "rgba(255,255,255,0.45)",
              display: "block",
            }}
          />
        </div>

        {/* Main heading */}
        <h2
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "#fff",
            fontWeight: 800,
            fontSize: "clamp(1.4rem, 4vw, 2.6rem)",
            lineHeight: 1.2,
            letterSpacing: "0.02em",
            textTransform: "uppercase",
            marginBottom: "1.25rem",
            textShadow: "0 2px 20px rgba(0,0,0,0.4)",
            maxWidth: 720,
          }}
        >
          Let's Talk to Transform Your Business
        </h2>

        {/* Divider */}
        <div
          style={{
            width: 48,
            height: 3,
            background: "#563D7C",
            borderRadius: 2,
            marginBottom: "1.25rem",
            opacity: 0.85,
          }}
        />

        {/* Subtitle */}
        <p
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            color: "rgba(255,255,255,0.8)",
            fontSize: "clamp(0.9rem, 1.8vw, 1.05rem)",
            lineHeight: 1.75,
            maxWidth: 520,
            marginBottom: "2rem",
            textShadow: "0 1px 8px rgba(0,0,0,0.3)",
          }}
        >
          Start the journey of transforming your business with a 15-minute
          meeting
        </p>

        {/* CTA */}
        <Link
          to="/Contactus"
          data-aos="fade-up"
          data-aos-duration="3000"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            background: "#563D7C",
            color: "#fff",
            fontWeight: 700,
            fontSize: "0.85rem",
            letterSpacing: "0.04em",
            padding: "0.75rem 2rem",
            borderRadius: 50,
            textDecoration: "none",
            boxShadow: "0 8px 28px rgba(86,61,124,0.45)",
            transition: "transform 0.2s, box-shadow 0.2s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow =
              "0 12px 36px rgba(86,61,124,0.55)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 28px rgba(86,61,124,0.45)";
          }}
        >
          Book a Meeting <span style={{ fontSize: "0.85rem" }}>→</span>
        </Link>
      </div>
    </div>
  );
};

export default WeareHere;
